import { render } from "./addSystemParameter.vue?vue&type=template&id=ca896c04"
import script from "./addSystemParameter.vue?vue&type=script&lang=js"
export * from "./addSystemParameter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__